import React, { useState, useEffect } from 'react';

export const Archor: React.FC<{
  children: any;
  href: string;
  onLinkClick: (data: any) => void;
  [key: string]: any;
}> = props => {
  const { href, children, onLinkClick, ...archorProps } = props;

  // 生成一下端内的schema，如果符合规则的话，否则为空
  const schema = archorProps['data-schema'] || '';
  // 生成文本对应的超链接地址，如果有的话
  // 如果没有href字段，那么看文本本身是否存在超链接字段
  const pattern = /^(http|https):\/\//;
  // 约定找所有子节点的文本是否有http|https开头的，有的话取最后一个
  const textHref = (children || []).reduce(
    (pre, cur) =>
      typeof cur === 'string' && pattern.test(cur.trim()) ? cur : pre,
    '',
  );

  const [target, setTarget] = useState<string>(href);

  const handleClick = (e: any) => {
    // 阻止默认事件，因为端内hydrate的逻辑里href的内容并不会被清除
    e.preventDefault();
    if (!target && !schema) {
      return;
    }
    if (onLinkClick) {
      onLinkClick({
        href: target,
        schema,
      });
    }
    // window.open(href);
  };

  useEffect(() => {
    if (textHref && !href) {
      // 这里是为了增加渲染逻辑，setState可以修改SSR模板的结构
      setTarget(textHref);
    }
  }, []);

  return (
    <a {...archorProps} rel="nofollow" onClick={handleClick} href={target}>
      {children}
    </a>
  );
};
